export const API_URL_PREFIX = 'https://api.cutemed.com/v2';
export const API_CLIENT_ID = 'DNkFaeRRp7Z3pHUa';
